var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScoreMatchingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1958",
    "data-name": "Rectangle 1958",
    width: 17,
    height: 17,
    transform: "translate(-0.001)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21995",
    "data-name": "Group 21995",
    transform: "translate(0.316 0.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21995-2",
    "data-name": "Group 21995",
    transform: "translate(-0.315 -0.561)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11208",
    "data-name": "Path 11208",
    d: "M16.1,0H.358A.358.358,0,0,0,0,.358V16.1a.358.358,0,0,0,.358.358H12.52a.356.356,0,0,0,.253-.1l3.577-3.577a.356.356,0,0,0,.1-.253V.358A.357.357,0,0,0,16.1,0M15.74,2.862H.715V.715H15.74ZM.715,3.577H15.74v7.87H14.309V5.366a.357.357,0,0,0-.358-.358H2.5a.358.358,0,0,0-.358.358v8.585a.358.358,0,0,0,.358.358h8.943V15.74H.715ZM11.8,11.447a.357.357,0,0,0-.358.358v1.789H8.585V5.724h5.008v5.724ZM2.862,5.724H7.87v7.87H2.862Zm9.51,10.016h-.21V12.163H15.74v.21Z",
    transform: "translate(0.07 0.325)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreMatchingIcon);
export default __webpack_public_path__ + "static/media/score-matching-icon.36916edfe43626a5595b46e84b102225.svg";
export { ForwardRef as ReactComponent };